module.exports = __webpack_public_path__ + "static/media/ticketalt.20c2afc4.svg";